import { VoiceGradient } from '@mint-lib/icons';
import { cn } from '@mint-lib/tw-utils';

import { Button } from '../../index.js';

type Props = {
  onClick: () => void;
};

const ChatVoice = ({ onClick }: Props) => {
  return (
    <Button
      aria-label="Voice"
      onClick={onClick}
      className={cn(
        'relative size-13 rounded-2xl border-double border-transparent-main bg-[linear-gradient(var(--color-ui-primary),var(--color-ui-primary)),linear-gradient(to_top_right,var(--color-ai-lightCyan),var(--color-ai-lightGreen))] [background-clip:content-box,border-box] p-0.5',
      )}
    >
      <span
        className={cn(
          'bg-linear-to-tr from-ai-activeCyan/15 to-ai-activeGreen/15',
          'hover:bg-linear-to-tr hover:from-ai-hoverCyan/30 hover:to-ai-hoverGreen/30',
          'active:bg-linear-to-tr active:from-ai-activeCyan/15 active:to-ai-activeGreen/15',
          'flex size-13 items-center justify-center rounded-2xl p-0.5',
        )}
      >
        <VoiceGradient className="size-5" />
      </span>
    </Button>
  );
};

export default ChatVoice;
